"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyDoc = exports.isEmptyBlock = exports.isEmptyText = exports.pluralize = exports.getSelectedText = exports.getWordCount = exports.getEditorPlainText = void 0;
const slate_1 = require("slate");
const getEditorPlainText = (editor) => slate_1.Node.string(editor).replace(/\s+$/g, '');
exports.getEditorPlainText = getEditorPlainText;
const getWordCount = (text) => {
    const words = text.trim().match(/\S+/g);
    return words ? words.length : 0;
};
exports.getWordCount = getWordCount;
const getSelectedText = (editor) => {
    const { selection } = editor;
    if (!selection || slate_1.Range.isCollapsed(selection))
        return '';
    return slate_1.Editor.string(editor, selection).trim();
};
exports.getSelectedText = getSelectedText;
const pluralize = (count, singular, plural = singular + 's') => `${Intl.NumberFormat().format(count)} ${count === 1 ? singular : plural}`;
exports.pluralize = pluralize;
const isEmptyText = (child) => {
    return slate_1.Text.isText(child) && !child.text && Object.keys(child).length === 1;
};
exports.isEmptyText = isEmptyText;
const isEmptyBlock = (element) => {
    const children = element.children;
    if (!children || children.length === 0)
        return true;
    if (children.length > 1)
        return false;
    const child = children[0];
    if ('children' in child)
        return false;
    return (0, exports.isEmptyText)(child);
};
exports.isEmptyBlock = isEmptyBlock;
const isEmptyDoc = (editor) => {
    const children = editor.children;
    if (!children)
        return true;
    const length = children.length;
    if (length === 0)
        return true;
    // Skip the hidden `.things` system block when judging emptiness.
    let start = 0;
    const first = children[0];
    if (slate_1.Element.isElement(first) && first.type === '.things')
        start = 1;
    const userLength = length - start;
    if (userLength === 0)
        return true;
    if (userLength > 1)
        return false;
    const firstChild = children[start];
    if (!slate_1.Element.isElement(firstChild))
        return false;
    if (firstChild.type !== 'p')
        return false;
    if (!firstChild.children)
        return true;
    return (0, exports.isEmptyBlock)(firstChild);
};
exports.isEmptyDoc = isEmptyDoc;
